// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3OSb6","name":"ConsentHeader_name__2VDaG","birthday":"ConsentHeader_birthday__rTIF2","skeleton":"ConsentHeader_skeleton__3PlSh"};